import React from "react";
import { StyleSheet, View, Image } from "@react-pdf/renderer";

export const BackgroundBlocks = ({ themeData }) => {
  const backgroundBlocks = StyleSheet.create({
    tlCircle: {
      position: "absolute",
      width: 300,
      height: 300,
      top: 0,
      left: 0,
    },
    tlStripes: {
      position: "absolute",
      width: 300,
      height: 300,
      top: 0,
      left: 0,
    },
    brCircle: {
      position: "absolute",
      width: 300,
      height: 300,
      right: 0,
      top: 500,
    },
    brStripes: {
      position: "absolute",
      width: 300,
      height: 300,
      right: 0,
      top: 600,
    },
  });

  return (
    <View data-testid="background-blocks">
      <Image
        src={themeData.tlBlockA}
        style={backgroundBlocks.tlStripes}
        aria-label="tl-stripes"
      />
      <Image
        src={themeData.tlBlockB}
        style={backgroundBlocks.tlCircle}
        aria-label="tl-circle"
      />
      <Image
        src={themeData.brBlockA}
        style={backgroundBlocks.brCircle}
        aria-label="br-circle"
      />
      <Image
        src={themeData.brBlockB}
        style={backgroundBlocks.brStripes}
        aria-label="br-stripes"
      />
    </View>
  );
};
